import RemoteSwitcherPlugin from '@atlassian/remote-module-loader/plugin-switcher';

import { getEnv } from '@townsquare/config';

export const remoteSwitcherPlugin = new RemoteSwitcherPlugin({
  env: getEnv().includes('prod') ? 'production' : 'staging',
  variant: 'latest',
});
